export default "__VITE_ASSET__DVZT4N1g__"